function t(n) {
  return n != null;
}
function i(n, e, r) {
  if (r < e)
    throw new Error(`The value of max ${r} is less than min ${e}`);
  return Math.min(Math.max(n, e), r);
}
export {
  i as clamp,
  t as isDefined
};
